export default {
  get_exact(state) {
    return state.exact_checkbox;
  },
};
